class LocalTime extends HTMLElement {
  connectedCallback() {
    const date = new Date(this.getAttribute('datetime'))
    if (Number.isNaN(date.getTime())) return

    this.textContent = new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date)
    this.title = date.toString()
  }
}

customElements.define('local-time', LocalTime)
